import { useSelector } from "react-redux";
// import Hamburger from "../../../../components/Hamburger";
// import Tooltip from "../../../../components/tooltip";
// import { RuvnlTitle } from "../../components";
// import { TabSwitcher } from "../../Raj_Dashboard";
// import SimulationTable from "./SimulationTable";
// import SimulationModHeader from "./SimulationModHeader";
import { useState } from "react";
import CostSellSimulationAnalysis from "./CostSellSimulationChart";
import CostPowerSimulationAnalysis from "./CostpowerSimulationChart";

export default function CostDemoSimulationIndex({
  open,
  selectedBlock,
  refreshKey,
  setError,
  selectedGeneratorName,
}: {
  open: boolean;
  selectedBlock: any[];
  selectedGeneratorName: any[];
  refreshKey: number;
  setError?: any;
}) {
  // const preSelectedDate = useSelector(
  //   (state: any) => state.modDemoDate.selectedDate
  // );
  // const modSelectedSession = useSelector(
  //   (state: any) => state.modDemoSession.modSession
  // );
  // const [open, setOpen] = useState(true);
  // const [refreshKey, setRefreshKey] = useState(0);
  // const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  // const [selectedGeneratorName, setSelectedGeneratorName] = useState<any[]>([]);

  // const formatDateWithSuffix = (dateString: string): string => {
  //   const date = new Date(dateString);
  //   const day = date.getDate();
  //   const year = date.getFullYear();
  //   //table
  //   const month = date.toLocaleString("default", { month: "long" });

  //   // Add suffix to the day (1st, 2nd, 3rd, etc.)
  //   const getDayWithSuffix = (d: number): string => {
  //     if (d > 3 && d < 21) return `${d}th`;
  //     switch (d % 10) {
  //       case 1:
  //         return `${d}st`;
  //       case 2:
  //         return `${d}nd`;
  //       case 3:
  //         return `${d}rd`;
  //       default:
  //         return `${d}th`;
  //     }
  //   };

  //   return `${getDayWithSuffix(day)} ${month} ${year}`;
  // };
  // const selectDate = formatDateWithSuffix(preSelectedDate);

  return (
    <>
      {/* <div className="w-full"> */}
      {/* <div className="dashboard-header flex items-center justify-between px-4">
          <div className="flex items-start w-28">
            <Hamburger />
            <div className="ms-5">
              <TabSwitcher />
            </div>
            <div>
              <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
                MeritEngine
              </h5>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <RuvnlTitle />
          </div>
          <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
            {selectDate}
          </h5>
        </div>
        <div className="h-[calc(-85px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-4">
            {/* <SimulationModHeader
              title={open ? "MeritEngine Simulator" : "Simulation Console"}
            /> */}
      {/* <div className=" flex flex-row gap-4 relative"> */}
      {/* <SimulationTable
                open={open}
                setOpen={setOpen}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
                selectedBlock={selectedBlock}
                setSelectedBlock={setSelectedBlock}
                selectedGeneratorName={selectedGeneratorName}
                setSelectedGeneratorName={setSelectedGeneratorName}
              /> */}

      <div
        className="load-data grid grid-cols-2 bg-white p-2 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-2 h-full w-full md:overflow-hidden  shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl"
        style={{
          height: "calc(-195px + 100vh)",
          width: "100%",
          marginLeft: "29%",
          filter: open ? "blur(0px)" : "blur(2px)",
          position: "relative",
          pointerEvents: open ? "auto" : "none",
          zIndex: "0",
        }}
      >
        <CostPowerSimulationAnalysis
          selectedBlock={selectedBlock}
          selectedGeneratorName={selectedGeneratorName}
          refreshKey={refreshKey}
          setError={setError}
        />

        <CostSellSimulationAnalysis
          selectedBlock={selectedBlock}
          selectedGeneratorName={selectedGeneratorName}
          refreshKey={refreshKey}
          setError={setError}
        />
      </div>
      {/* </div> */}
      {/* </div>
        </div> */}

      {/* </div> */}
    </>
  );
}
